google.charts.load('current', {'packages': ['corechart', 'controls'], 'callback': drawChart});
// Set a callback to run when the Google Visualization API is loaded.

var dateRangeOptionNames = new Object();
dateRangeOptionNames['7'] = 'w';
dateRangeOptionNames['30'] = 'm';
dateRangeOptionNames['60'] = '2m';
dateRangeOptionNames['90'] = '3m';
dateRangeOptionNames['180'] = '6m';
dateRangeOptionNames['270'] = '9m';
dateRangeOptionNames['365'] = '1y';
dateRangeOptionNames['730'] = '2y';
dateRangeOptionNames['1095'] = '3y';
dateRangeOptionNames['1460'] = '4y';

function drawChart(AREA, OILTYPE, DAYS, COMPARE, ID, VAT, HEIGHT, WIDTH, RENDER, EXCLUDETODAY, chart_area) {
    HEIGHT = typeof HEIGHT !== 'undefined' ? HEIGHT : 520;
    WIDTH = typeof WIDTH !== 'undefined' ? WIDTH : false;
    RENDER = typeof RENDER !== 'undefined' ? RENDER : false;
    VAT = typeof VAT !== 'undefined' ? VAT : '1';
    EXCLUDETODAY = typeof EXCLUDETODAY !== 'undefined' ? EXCLUDETODAY : '1';
    chart_area = typeof chart_area !== 'undefined' ? chart_area : {};

    const SCALE_RATIO = (WIDTH !== false) ? WIDTH / 660 : 1; // equal to default graph resolution or 1

    const vAxisTitle = 'Price (pence/litre' + ((VAT === 1) ? ' incl. 5% VAT' : '') + ')';

    // if area is undefined, return
    if (AREA === undefined) return;

    let pointSizePX = 7;

    if (DAYS > 30) {
        pointSizePX = 5;
    }
    if (DAYS > 90) {
        pointSizePX = 0;
    }

    let chartAreaValues = {
        width: typeof chart_area.width !== 'undefined' ? chart_area.width : "90%",
        height: typeof chart_area.height !== 'undefined' ? chart_area.height : "70%",
        top: typeof chart_area.top !== 'undefined' ? chart_area.height : '5%',
        left: typeof chart_area.left !== 'undefined' ? chart_area.left : '10%'
    };

    if (OILTYPE < 0) OILTYPE *= -1;
    const url = "/uk/ajax/price_chart";
    const request = $.ajax({
        url: url,
        type: 'GET',
        data: {
            area: AREA,
            oilType: OILTYPE,
            days: DAYS,
            vat: VAT,
            ex: EXCLUDETODAY
        },
        dataType: "html",
    }).then(
        function (response) {
            // Convert invalid Ruby-style JSON to proper JSON
            response = response.replace(/=>/g, ":").replace(/nil/g, "null");

            // Now, parse the corrected JSON
            data = JSON.parse(response);

            if (data.error) {
                console.log("Request failed: " + data.error);
                return;
            } else if (data.rows.length > 0) {
                // Set chart options
                var options = {
                    height: HEIGHT,
                    curveType: 'none',
                    crosshair: {
                        color: '#0272BE'
                    },
                    chartArea: {
                        width: chartAreaValues.width,
                        height: chartAreaValues.height,
                        top: chartAreaValues.top,
                        left: chartAreaValues.left,
                        backgroundColor: '#E4EAF0'
                    },
                    hAxis: {
                        format: 'Y,M,d',
                        baselineColor: '#0272BE',
                        textStyle: {
                            italic: false,
                            color: '#909090',
                            fontSize: Math.round(12 * SCALE_RATIO),
                        },
                        gridlines: {
                            color: "#f5f7f9",
                        },
                        minorGridlines: {
                            count: 2
                        },
                    },
                    vAxis: {
                        baselineColor: '#0272BE',
                        gridlineColor: "#f5f7f9",
                        title: vAxisTitle,
                        titleTextStyle: {
                            italic: false,
                            color: '#909090',
                            fontSize: Math.round(12 * SCALE_RATIO),
                        },
                        textStyle: {
                            color: '#132629',
                            fontName: 'Poppins',
                            fontSize: Math.round(12 * SCALE_RATIO),
                        },
                    },
                    series: {
                        0: {
                            color: '#F15A25',
                            backgroundColor: 'none',
                            pointShape: 'circle',
                            lineWidth: 2,
                            pointSize: pointSizePX,
                            visibleInLegend: false,
                            areaOpacity: 0.0,
                        },
                        1: {
                            color: '#F4F7F9',
                            pointShape: 'circle',
                            visibleInLegend: false,
                            lineWidth: 0,
                            pointSize: 0,
                            areaOpacity: 1,
                        },
                        2: {
                            color: '#FFFFFF',
                            pointShape: 'circle',
                            visibleInLegend: false,
                            lineWidth: 0,
                            pointSize: Math.round(pointSizePX / 2),
                            areaOpacity: 0.0,
                        },
                    },
                    focusTarget: 'category',
                    animation: {
                        duration: 200,
                        easing: 'in'
                    },
                    legend: {
                        position: 'top',
                        textStyle: {
                            color: '#0272BE',
                            fontSize: Math.round(16 * SCALE_RATIO),
                        }
                    },
                    tooltip: {
                        isHtml: true,
                        trigger: 'both'
                    },
                };

                // Set Width if set (otherwise ignore and set to auto)
                if (WIDTH != false) options.width = WIDTH;

                var elementId = ID;
                var max_hAxis_labels = 10;

                // Create our data table out of JSON data loaded from server.
                var data = new google.visualization.DataTable(data);
                var view = new google.visualization.DataView(data);
                var no_rows = data.getNumberOfRows();
                if (no_rows > max_hAxis_labels) {
                    options.hAxis.showTextEvery = parseInt((no_rows + max_hAxis_labels - 1) / max_hAxis_labels);
                }
                options.hAxis.slantedText = true;
                options.hAxis.slantedTextAngle = 45;

                view.setColumns([0, 1, 1, 1]);

                // Instantiate and draw our chart, passing in some options.
                var chart = new google.visualization.AreaChart(document.getElementById(elementId));

                // Wait for the chart to finish drawing before calling the getImageURI() method.
                if (RENDER == 'png') {
                    google.visualization.events.addListener(chart, 'ready', function () {
                        chart_div.innerHTML = '<img src="' + chart.getImageURI() + '">';
                    });
                }
                chart.draw(view, options);
            }
        },
        function (jqXHR, textStatus, errorThrown) {
            console.log("Error:", textStatus, errorThrown);
        }
    );
}

function drawPoints(chart, DAYS) {
    google.visualization.events.addListener(chart, 'ready', function () {
        var count = 0;
        var offset = 90;
        if (DAYS <= 1460) offset = 30;
        if (DAYS <= 180) offset = 7;
        if (DAYS <= 60) offset = 1;
        var radius = 2;
        $('circle').each(function () {
            var $c = $(this);

            if (count % offset == 0) {
                var circles = document.createElementNS("http://www.w3.org/2000/svg", "circle");
                circles.setAttribute("cx", $c.attr('cx'));
                circles.setAttribute("cy", $c.attr('cy'));
                circles.setAttribute("r", radius);
                circles.setAttribute("fill", $c.attr('fill'));
                circles.setAttribute("stroke", '#F15A25');
                circles.setAttribute("stroke-width", '7');
                if (this.parentElement == undefined)
                    this.appendChild(circles);
                else
                    this.parentElement.appendChild(circles);

                circles = document.createElementNS("http://www.w3.org/2000/svg", "circle");
                circles.setAttribute("cx", $c.attr('cx'));
                circles.setAttribute("cy", $c.attr('cy'));
                circles.setAttribute("r", radius + 1);
                circles.setAttribute("fill", "white");
                if (this.parentElement == undefined)
                    this.appendChild(circles);
                else
                    this.parentElement.appendChild(circles);

            }
            count++;
        });
    });
}

function bindOnChange(region, oilType, vat, excludeToday) {
    $("input[name*='date_range']").change(function () {
        drawChart(region, oilType, this.value, '0', 'chart_div', vat, false, false, false, excludeToday);
    });

    $('select#price_chart_dropdown').change(function () {
        // Grab the option selected value
        var days = $(this).find("option:selected").attr('value');

        let $chartData = $("#graph-hidden-data");
        let region = $chartData.data('region');
        let oilType = $chartData.data('oiltype');
        let vat = $chartData.data('vat');

        let height = 420;
        let width = $("#chart_div").width();

        // Re draw the price chart
        drawChart(region, oilType, days, '0', 'chart_div', vat, height, width, false, excludeToday);
    });
}

function reDrawGoogleChart(region, oilType, vat, excludeToday) {

// Grab the option selected value
    var days = $('select#price_chart_dropdown').find("option:selected").attr('value');
// Re draw the price chart
    drawChart(region, oilType, days, '0', 'chart_div', vat, false, false, false, excludeToday);
}

$(document).ready(function () {
    let $chartData = $("#graph-hidden-data");
    let region = $chartData.data('region');
    let oilType = $chartData.data('oiltype');
    let vat = $chartData.data('vat');
    let width = $("#chart_div").width();
    let days_default = $chartData.data('daysdefault');
    let height = 420;

    // Draw the google chart
    drawChart(region, oilType, days_default, '0', 'chart_div', vat, height, width, false, 0);
    bindOnChange(region, oilType, vat, '0');

    // We don't want to run the reDrawGoogleChart when the screen size changes over one
    // of the break points as well as the screen being detected as changing orientation,
    // So by default set Orientation check as true, but gets set to false when screen
    // size goes over a break point
    let runOrintationCheck = true;

    // Check for screen resize
    $(window).resize(function () {

        // This resets the runOrintationCheck var when its set to false down below if
        // one of the break points is hit
        runOrintationCheck = true;

        // Check if current width is >= 1200
        if (width >= 1200) {

            // If the screen width goes below the break point, re draw the price chart to fit the screen
            if ($(this).width() < 1200) {
                // draw the google chart
                reDrawGoogleChart(region, oilType, vat);
                // Set the width var to the new width
                width = $(this).width();
                runOrintationCheck = false;
            }
        }

        if (width >= 992 && width < 1200) {
            if ($(this).width() < 992 || $(this).width() > 1199) {
                reDrawGoogleChart(region, oilType, vat);
                width = $(this).width();
                runOrintationCheck = false;
            }
        }

        if (width >= 768 && width < 992) {
            if ($(this).width() < 768 || $(this).width() > 991) {
                reDrawGoogleChart(region, oilType, vat);
                width = $(this).width();
                runOrintationCheck = false;
            }
        }

        if (width >= 540 && width < 640) {
            if ($(this).width() < 540 || $(this).width() > 639) {
                reDrawGoogleChart(region, oilType, vat);
                width = $(this).width();
                runOrintationCheck = false;
            }
        }

        if (width >= 640 && width < 768) {
            if ($(this).width() < 640 || $(this).width() > 767) {
                reDrawGoogleChart(region, oilType, vat);
                width = $(this).width();
                runOrintationCheck = false;
            }
        }

    });

    // Change on screen orientation
    $(window).on("orientationchange", function () {
        if (runOrintationCheck) {
            reDrawGoogleChart(region, oilType, vat);
        }
    });

});